import React from 'react';
import { useEffect } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';
import { colors } from '../../theme';
import { CMSContent } from '../../containers/cmscontent/CMSContent';

const pardotFormUrl = process.env.DEMO_PARDOT_FORM_URL;

const useStyles = makeStyles()((theme: Theme) =>
    ({
        scheduleDemo: {
            flexGrow: 1,
            width: '100%',
            flexDirection: 'column',
            display: 'flex',
            margin: 0,
            position: 'relative',
            backgroundColor: colors.blue,
        },

        bar: {
            flexDirection: 'row',
            display: 'flex',
            justifyContent: 'center',
            padding: theme.spacing(10),
        },

        splitBox: {
            minHeight: 900,
            flex: 1,
            display: 'flex',
            justifyContent: 'flex-start',
            flexDirection: 'column',
            alignItems: 'center',
            position: 'relative',
            margin: theme.spacing(2),
        },

        pardotForm:{
            height: "100%",
            width: "100%",
            backgroundColor: colors.white,
        }
    }));

const LandingRequestDemoPage: React.FC = () => {
    const { classes } = useStyles();

    useEffect(() => {}, []);

    return (
        <div className={classes.scheduleDemo}>
            <div className={classes.bar}>
                <div className={classes.splitBox}>
                    <iframe className={classes.pardotForm} src={pardotFormUrl} title="Contact Form" frameBorder="0"></iframe>
                </div>
                <div className={classes.splitBox}>
                    <CMSContent type="page" name="demo-other" />
                </div>
            </div>
        </div>
    );
};

export default LandingRequestDemoPage;
